// TODO: useIsAppWebViewへの移行が完了したら削除する
// SSRとクライアントで返り値が異なるためhydration不一致を起こす可能性がある
// useEffect内でのみ参照する場合は問題ない
const isAppWebView = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const ua = window.navigator.userAgent;
  return (
    ua.indexOf('Gaishishukatsu iOS App') > 0 ||
    ua.indexOf('Gaishishukatsu Android App') > 0
  );
};

export default isAppWebView;
